import React, { useEffect, useRef, useState } from 'react'
import Head from 'next/head'
import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import styles from './credit.module.scss';
import Image from 'next/image';
import Layout from '../../../../src/components/layout';
import pageBg from '../../../../public/images/credit-bg.jpg';
import creditLogo from '../../../../public/images/credit-logos.png'
import cLogoBg from '../../../../public/images/cLogo-bg.png'
import { useRouter } from 'next/router';
// Register Plugin
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function StoryCredit({dataAudio, dataAudio2}) {
    const bgData = {
        bgImage: pageBg
    }
    const pageData = {
        section1: {
            title: 'קרדיטים',
            credits: [
                {
                    title: 'הובלה וניהול פרויקט',
                    name: 'נעמי גלבך',
                    id: 1,
                },
                {
                    title: 'תוכן וארכיון',
                    name: 'טובה יוסקוביץ',
                    id: 2,
                },
                {
                    title: 'ייעוץ היסטורי',
                    name: 'גב’ אסתר פרבשטיין',
                    id: 3,
                },
                {
                    title: 'כתיבת תוכן',
                    name: 'רחל שטיינהויז',
                    id: 4,
                },
                {
                    title: 'אפיון ועיצוב',
                    name: 'נעמי גלבך, יובל אלבג',
                    id: 5,
                },
                {
                    title: 'איור ואנימציה',
                    name: 'תמר דדון-רווה',
                    id: 6,
                },
                {
                    title: 'איור',
                    name: 'נעה פלד',
                    id: 7,
                },
                {
                    title: 'מחקר היסטורי סגנוני',
                    name: 'אפרת יפה',
                    id: 8,
                },
                {
                    title: 'פיתוח',
                    name: 'SiTo',
                    link: "https://sito.ltd/?utm_source=bamistarim&utm_medium=credit&utm_campaign=bamistarim",
                    target: "_blank",
                    id: 9,
                },
                {
                    title: 'מוסיקה מקורית ועיצוב סאונד',
                    name: 'דניאל שמר',
                    id: 10,
                },
                {
                    title: 'הפקת פודקאסטים',
                    name: 'רבקי וקסלר',
                    id: 11,
                },
                {
                    title: 'קטעי תיעוד ותמונות',
                    name: 'ארכיון גנזך קדוש השם',
                    id: 12,
                }
            ],

        },
        section2: {
            content: '<p>With Assistance from the Conference on Jewish Material Claims Against Germany<br/>Sponsored by the Foundation "Remembrance, Responsibility and Future"<br/>Supported by the German Federal Ministry of Finance</p>'
        },
        logoSection: {
            logos: creditLogo,
            creditBG: cLogoBg
        }
    }
    //console.log(pageData?.logoSection?.creditBG?.src);

    // Set Counter
    const [counter, setCounter] = useState(1);

    // Use Ref
    const scroller = useRef(null);
    const credits = useRef(null);
    // Router
    const router = useRouter();
    //console.log(router.asPath);

    useEffect(() => {
        const contain = document.querySelector(".vertical-wrapper");
        /* console.log(window.innerHeight);
        console.log(scroller.current.scrollHeight);
        if(scroller.current){
            ScrollTrigger.create({
                trigger: scroller.current,
                start: "top top",
                end: () => (scroller.current.scrollHeight - window.innerHeight),
                pin: true,
                anticipatePin: 1,
                scrub: 2,
                invalidateOnRefresh: true,
            });
        } */
        // Timeline
        if(credits) {
            const auto = gsap.timeline({ repeat: 0, delay: 3 })
            .to(credits.current, {
                y: () => { return -(credits.current.scrollHeight - window.innerHeight) },
                duration: 20,
                progress: 0.5,
                ease: "none",
                autoKill:true
            });

            auto.resume();

            contain.addEventListener("wheel", function(e){
                let time = 1;
                if(e.deltaY < 0) {
                    if(e.deltaY < -100) {
                        time = time + 0.5;
                    } else if(e.deltaY < -200) {
                        time = time + 1;
                    } else if(e.deltaY < -300) {
                        time = time + 1.5;
                    } else if(e.deltaY < -400) {
                        time = time + 2;
                    } else {
                        time = time + 3;
                    }
                    auto.timeScale(time).reverse();
                } else {
                    if(e.deltaY < 100) {
                        time = time + 0.5;
                    } else if(e.deltaY < 200) {
                        time = time + 1;
                    } else if(e.deltaY < 300) {
                        time = time + 1.5;
                    } else if(e.deltaY < 400) {
                        time = time + 2;
                    } else {
                        time = time + 3;
                    }
                    auto.timeScale(time).play();
                }
            });
        }

    }, [router.asPath]);
  return (
    <Layout header='show' footer='hide' mainDir='ltr' audio={dataAudio} audio2={dataAudio2}>
      <Head>
        <meta name="robots" content="noindex"></meta>
      </Head>
      <section className={`vertical-wrapper relative h-screen w-screen overflow-hidden z-10 flex flex-nowrap flex-row-reverse bg-no-repeat bg-fixed bg-center bg-cover ${styles.container}`}>
        <div className={`absolute top-0 right-0 w-full h-full z-10 ${styles.background}`}>
            <Image
                className='block w-full h-full object-cover object-center'
                src={pageBg?.src}
                width={pageBg?.width}
                height={pageBg?.height}
                blurDataURL={pageBg?.blurDataURL}
                placeholder={'blur'}
                alt={pageBg?.alt}
            />
        </div>
        
        <div 
        className={`v-section w-screen h-auto z-50 flex content-center justify-center`}>
            <div className='w-screen h-auto creditScroll'>
                <div 
                ref={scroller}
                className='w-screen h-auto section-wrapper'>
                    <div 
                    ref={credits}
                    className={`${styles.creditContent}`}>
                        <div className={styles.section1}>
                            <h2 className={styles.title}>{pageData?.section1?.title}</h2>
                            <div className='credits'>
                            {pageData?.section1?.credits?.map((item) => {
                                return(
                                    <div className={`flex justify-between ${styles.singleList}`} key={item.id}>
                                        <div className={styles.listLeft}>
                                            <p>{item.link ? (
                                                <a href={item.link} target={item.target}>{item.name}</a>
                                            ) : item.name }</p>
                                        </div>
                                        <div className={styles.listRight}>
                                            <p>{item.title}</p>
                                        </div>
                                    </div>
                                )
                            })}
                            </div>
                        </div>
                        <div className={styles.section2}>
                            <div className='credits m-auto max-w-4xl text-center' dangerouslySetInnerHTML={{__html: pageData?.section2?.content}}></div>
                        </div>
                    </div>
                </div>
            </div>

            <div 
            style={{backgroundImage: `url('${pageData?.logoSection?.creditBG?.src}')`}}
            className={`flex justify-center bg-no-repeat fixed left-0 bottom-0 z-40 w-full ${styles.creditLogo}`}>
                <Image 
                width={pageData?.logoSection?.logos?.width}
                height={pageData?.logoSection?.logos?.height}
                src={pageData?.logoSection?.logos?.src}
                blurDataURL={pageData?.logoSection?.logos?.blurDataURL}
                placeholder={'blur'}
                alt={pageData?.logoSection?.logos?.alt} />
            </div>
        </div>
      </section>
    </Layout>
  )
}

export default StoryCredit;